import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaFilter } from 'react-icons/fa';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { CSVLink } from 'react-csv';

import ApiUiController from '../../controller/ApiUiController';
import FieldController from '../../controller/FieldController';
import ReportAPI from '../../api/ReportAPI';
import TargetAPI from '../../api/TargetAPI';
import FilterDate from '../filter/FilterDate';
import FilterPannel from '../filter/FilterPannel';
import FilterMultiSelect from '../filter/FilterMultiSelect';
import Const from '../../util/Constants';
import withRouter from '../../util/WithRouter';
import Util from '../../util/Util';

class ReportTarget extends React.Component {

  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);

    this.export = [];

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.children = [user.user_id, ...user.child];

    this.report = props.report;
    this.rows = [];
    this.data = null;

    this.report.model = this.report.sub_model;
    this.model = this.models[this.report.model];
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);
    const filters = [];
    if (this.report.filter) {
      const filter = JSON.parse(this.report.filter);
      for (let i = 0; i < filter.length; i++) {
        filters.push({ ...filter[i] });
        filters[i].value = FilterDate.getValue(filters[i].value);
      }
    }

    if (props.filters) {
      for (let i = 0; i < props.filters.length; i++) {
        const filter = { ...props.filters[i] };
        filter.value = FilterDate.getValue(props.filters[i].value);
        filter.value = FilterMultiSelect.getDefaultValue(filter.value);
        let j = 0;
        for (; j < filters.length; j++) if (filters[j].field === filter.field) break;
        if (j === filters.length) filters.push(filter);
        else filters[j] = filter;
      }
    }
    this.filters = filters;
    /*
        const PieConfig = {
          chart: {
              plotBackgroundColor: null,
              plotBorderWidth: null,
              plotShadow: false,
              type: 'pie'
          },
          title: {
              text: 'Browser market shares in January, 2018'
          },
          tooltip: {
              pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          accessibility: {
              point: {
                  valueSuffix: '%'
              }
          },
          plotOptions: {
              pie: {
                  allowPointSelect: true,
                  cursor: 'pointer',
                  dataLabels: {
                      enabled: true,
                      format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                  }
              }
          },
          series: [{
              name: 'Brands',
              colorByPoint: true,
              data: [{
                  name: 'Chrome',
                  y: 61.41,
                  sliced: true,
                  selected: true
              }, 
              {
                  name: 'Internet Explorer',
                  y: 11.84
              }, 
              {
                  name: 'Firefox',
                  y: 10.85
              }, 
              {
                  name: 'Other',
                  y: 2.61
              }]
          }]   
        };
    */

    this.state = { isFilterOpen: true, inApiCall: false };
  }

  componentDidMount() { TargetAPI.getLog(this.report.x, this.onTarget, () => { }); }

  onTarget = res => {
    this.target = JSON.parse(res.target);
    this.loadReports();
  };

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onData = res => {
    this.data = this.calculte(res);
    this.setState({ ...this.state, inApiCall: false });
  };

  onFilterChange = filters => {
    this.filters = filters;
    this.setState({ ...this.state, inApiCall: true });
    this.loadReports();
  };

  loadReports = () => {
    const restrict = this.filters.find(filter => filter.field === 'responsible_person');
    if (this.Restrict && !restrict) {
      this.filters.push({
        field: 'responsible_person', type: 'multiselect~user',
        condition: 'in', value: `${Const.Opt}${this.children.join(Const.Opt)}${Const.Opt}`
      });
    }
    ReportAPI.data(this.report.id, this.filters, this.onData, this.onFail);
  };

  calculte = res => {
    const model = this.models[this.report.model];
    if (!model) return { headers: [], body: [] };

    const y = this.report.y;

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const children = [user.user_id, ...user.child];

    let yOptions = FieldController.getOptions(model.fields[y], undefined, true);
    if (this.restrict && model.fields[y].field_type.includes('~user')) {
      yOptions = yOptions.filter(opt =>
        children.find(child => parseInt(child) === parseInt(opt.value)) !== undefined);
    }
    let filter = this.filters.find(filter => filter.field === model.fields[y].field_key);
    if (filter) yOptions = yOptions.filter(opt =>
      filter.value.includes(`${Const.Opt}${opt.value}${Const.Opt}`));
    yOptions = yOptions.filter(opt => this.target.find(tag => tag.user === opt.value));
    this.yOptions = yOptions;

    let rows = yOptions.map(option => option.label);
    const body = [];
    let total = 0;
    let totalTarget = 0;
    for (let i = 0; i < rows.length; i++) {
      const yVal = yOptions[i].value;
      let yType = model.fields[y].field_type;
      yType = yType.includes(Const.MultiSelect);

      const tmp = yType ? res.filter(itm => itm[y].includes(`~${yVal}~`))
        : res.filter(item => item[y] === yVal);
      let count = 0;
      for (let k = 0; k < tmp.length; k++) {
        count += tmp[k].sum;
      }
      total += count;
      const target = this.target.find(tag => tag.user === yOptions[i].value).target;
      totalTarget += target;
      const percent = Math.floor(count * 100 / target);
      body.push([rows[i], target, count, percent]);
    }
    const percent = Math.floor(total * 100 / totalTarget);
    body.push(['Total', totalTarget, total, percent]);

    this.export = [[this.model.fields[this.report.y].label_name], ...body];
    return body;
  };

  loadView = (i, j) => {
    if (j === 0) return;
    let value;
    if (i < this.yOptions.length) { value = `${Const.Opt}${this.yOptions[i].value}${Const.Opt}`; }
    else { value = `${Const.Opt}${this.yOptions.map(opt => opt.value).join(Const.Opt)}${Const.Opt}`; }
    const type = this.models[this.report.model].fields[this.report.y].field_type;
    const filters = [...this.filters, { field: this.report.y, type, condition: 'in', value }];
    const model = this.report.model !== 'sales_order' ? this.report.model : 'sales-order';
    this.props.navigate(`/${model}?filters=${JSON.stringify(filters)}`);
  };

  render() {
    const body = this.data ? this.data.map((row, i) =>
      <tr key={`body_${i}`}>{row.map((item, j) =>
        <td key={`body_${i}_${j}`} onClick={() => this.loadView(i, j)}>{item}</td>)}</tr>)
      : null;

    let table = <Table striped bordered hover>
      <thead>
        <tr>
          <th>{this.model.fields[this.report.y].label_name}</th>
          <th>Target</th>
          <th>Achieved</th>
          <th>Achieved %</th>
        </tr>
      </thead>
      <tbody className="listlead">{body}</tbody>
    </Table>;

    if (this.props.dashbaord) {
      return (
        <div className="col-md-4">
          <div className="dashboard-report-titles mt-3"><h4>{this.report.name}</h4></div>
          <div> <ApiUiController inApiCall={this.state.inApiCall}> {table} </ApiUiController> </div>
        </div>
      );
    }

    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <div className="container-fluid ">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6"><h4>{this.report.name}</h4></div>
                <div className="col-md-6">
                  <CSVLink data={this.export} filename={`${this.report.name}.csv`}>
                    <Button className="buttons btn-success">Export</Button>
                  </CSVLink>
                </div>
              </div>
            </div>
            <div className="col-md-4 pt-1">
              <div className="row filterrow">
                <div className="col-md-12 lastcol">
                  <div className="m-right">
                    <div className="btn btn-lead btn-sm filter-button"
                      onClick={() => this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen })}>
                      <FaFilter />
                      <span className="badge badge-danger badge-mini rounded-circle">
                        {this.filters.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-3">
            <div className="container-fluid ">
              <div className="row">
                <div className={`col-md-${this.state.isFilterOpen ? 9 : 12}`}>
                  {table}
                  { /*
                {this.data ? <BarGaph data={this.data} report={this.report}/> : null}
                {this.data ? <PieGraph data={this.data} report={this.report}/> : null}
                */}

                </div>
                {this.state.isFilterOpen ?
                  <FilterPannel filters={this.filters} fields={this.model.fields}
                    onFilterChange={this.onFilterChange} isFilterOpen={true} restrict={this.Restrict} />
                  : null
                }
              </div>
            </div>
          </div>
          <div classname="row mb-5">
            <div classname="col-md-12">

            </div>
          </div>
        </div>
      </ApiUiController>
    );
  }
}
export default withRouter(ReportTarget);